import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import UnauthorizedPage from '../auth/pages/UnauthorizedPage';
import LoadingOverlay from '../components/Loading/LoadingOverlay';
import { useAuthUser } from '../hooks/auth/useAuthUser';

interface RoleProtectedRouteProps {
  allowedRoles: readonly string[];
}

const RoleProtectedRoute = ({ allowedRoles }: RoleProtectedRouteProps) => {
  const { roles, isLoading, hasLoaded, fetchRoles } = useAuthUser();

  useEffect(() => {
    if (!hasLoaded && !isLoading) void fetchRoles();
  }, [hasLoaded, isLoading]);

  if (!hasLoaded || isLoading) return <LoadingOverlay />;

  return allowedRoles.some((role) => roles.includes(role)) ? (
    <Outlet />
  ) : (
    <UnauthorizedPage />
  );
};

export default RoleProtectedRoute;
